export default __webpack_public_path__ + "static/media/ETA Change_Dark2.c663da5d.svg";